var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EntitySelect',{attrs:{"current":_vm.checkupStore.personEntity,"isActive":_vm.isActive,"placeholder":_vm.personEntitySearchPlaceholder},on:{"select":_vm.addPersonEntity}})
}
var staticRenderFns = []

export { render, staticRenderFns }